export default class FastOrder {
    constructor(data) {
        this.data = data;
        this.state = 'fill';

        this.$popup = $(this.popupTemplate());
        $('body').append(this.$popup);
        $("input[name='user_phone']").inputmask("+7(999)999-99-99");
        this.$popup.modal('show');

        this.$popup.find('.fast-order-modal__submit').on('click', this.onSubmit.bind(this));
        this.$popup.on('hidden.bs.modal', this.onClose.bind(this));
    }

    popupTemplate() {
        return `
            <div class="modal fade simple-modal fast-order-modal" id="fast-order-modal" tabindex="-1" role="dialog"  aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="close simple-modal__close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div class="simple-modal__title">Быстрый заказ</div>
                            <div class="simple-modal__subtitle">
                                Оставьте свои данные и наш менеджер свяжется с вами для уточнения условий заказа
                            </div>

                            <div class="fast-order-modal__form">
                                <input type="hidden" name="_key" value="qp37rp5tOgDQq" />
                                <div class="form-group">
                                    <input type="text"
                                        class="lb-input fast-order-modal__input fast-order-modal__input--name"
                                        placeholder="Ваше ФИО"
                                        required
                                    />
                                </div>
                                <div class="form-group">
                                    <input type="text"
                                        class="fast-order-modal__input fast-order-modal__input--phone lb-input"
                                        placeholder="Ваш номер телефона" name="user_phone"
                                        required
                                    />
                                </div>
                                <div class="form-group">
                                    <input type="text"
                                        class="fast-order-modal__input fast-order-modal__input--email lb-input"
                                        placeholder="Ваш E-mail"
                                    />
                                </div>
                                
                                <div class="fast-order-modal__success hidden">Спасибо, мы скоро с вами свяжемся</div>
                            </div>

                            <div>
                                <div class="fast-order-modal__subtitle">Приобретаемый товар:</div>
                                <div class="fast-order-modal__product">${this.productTemplate(this.data.product)}</div>
                                <div class="fast-order-modal__notice">Наличие товара уточняйте у продавцов</div>

                                <div class="fast-order-modal__btn-block">
                                    <button class="button-icon fast-order-modal__submit">
                                          <span class="button-icon__left">
                                              <img src="${app.assetPath}/img/icons/smartphone-white.svg" alt="" class="button-icon__icon" />
                                          </span>
                                        <span class="button-icon__right">Заказать</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    productTemplate(product) {
        return `
            <img src="${product.image}" alt="" class="fast-order-modal__product-img">
            <div class="fast-order-modal__product-content">
                <span class="fast-order-modal__product-title">${product.name}</span>
                <div class="fast-order-modal__product-price">${product.mainPrice.name}: <span>${product.mainPrice.value}</span></div>
                ${product.otherPrice ? `<div class="fast-order-modal__product-price">${product.otherPrice.name}: <span>${product.otherPrice.value}</span></div>` : ''}
            </div>
        `;
    }

    onSubmit() {
        switch (this.state) {
            case 'sent':
                this.$popup.modal('hide');
                //this.$popup.remove();
                //delete this;

                break;

            case 'fill':
            default:
                const name = this.$popup.find('.fast-order-modal__input--name').val();
                const phone = this.$popup.find('.fast-order-modal__input--phone').val();
                const email = this.$popup.find('.fast-order-modal__input--email').val();

                if (name == '' || (phone == '' && email == '')) {
                    alert('Заполните поля');
                    return;
                }

                $.ajax({
                    url: '/local/public/fast_order.php',
                    dataType: 'json',
                    method: 'post',
                    data: {
                        productId: this.data.product.id,
                        name,
                        phone,
                        email,
                        ajax: 'Y',
                        formId: 'callback',
                        _protect: this.$popup.find('input[name="_key"]').val().substr(3),
                        sessid: app.sessid
                    }
                }).done((response) => {
                    if (response.status == 'error') {
                        let errors = '';

                        if (response.error) {
                            errors = response.error;
                        } else {
                            for (var i = 0; i < response.errors.length; i++) {
                                errors += response.errors[i].text + '\n';
                            }
                        }

                        alert(errors);
                        return;
                    }

                    this.$popup.find('.fast-order-modal__success').removeClass('hidden');
                    this.$popup.find('.fast-order-modal__submit .button-icon__left').addClass('hidden');
                    this.$popup.find('.fast-order-modal__submit .button-icon__right').text('Закрыть');
                    this.state = 'sent';
                });

                break;
        }
    }

    onClose() {
        this.$popup.modal('dispose');
        delete this;
    }
}